export default function getUserRatingLabelIntlId(userScore: number): string {
  if (userScore >= 8) {
    return 'product_card_user_rating_fantastic'
  }
  else if (userScore >= 6) {
    return 'product_card_user_rating_good'
  }
  else if (userScore >= 4) {
    return 'product_card_user_rating_average'
  }
  else if (userScore >= 2) {
    return 'product_card_user_rating_reasonable'
  }

  return 'product_card_user_rating_unsatisfied'
}
